// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Json = require("../../Json.bs.js");
var Curry = require("bs-platform/lib/js/curry.js");
var TypeUtils = require("../TypeUtils.bs.js");
var Relude_Float = require("relude/src/Relude_Float.bs.js");
var Relude_Option = require("relude/src/Relude_Option.bs.js");
var Relude_Result = require("relude/src/Relude_Result.bs.js");
var Relude_String = require("relude/src/Relude_String.bs.js");
var Relude_Globals = require("relude/src/Relude_Globals.bs.js");
var CommonTypes_Guid = require("../CommonTypes_Guid.bs.js");

var include = TypeUtils.MakeOpaqueStringType({});

var decode = include.decode;

var encode = include.encode;

function parse(param) {
  return Relude_Globals.$great$great((function (param) {
                return Relude_Globals.$great$great(decode, Relude_Result.getOk, param);
              }), Relude_Option.getOrThrow, param);
}

var GraphQL_API = {
  parse: parse,
  serialize: encode
};

var BusinessName_fromString = include.fromString;

var BusinessName_toString = include.toString;

var BusinessName_compare = include.compare;

var BusinessName_eq = include.eq;

var BusinessName_Ord = include.Ord;

var BusinessName_Set = include.$$Set;

var BusinessName_Map = include.$$Map;

var BusinessName = {
  fromString: BusinessName_fromString,
  toString: BusinessName_toString,
  decode: decode,
  encode: encode,
  compare: BusinessName_compare,
  eq: BusinessName_eq,
  Ord: BusinessName_Ord,
  $$Set: BusinessName_Set,
  $$Map: BusinessName_Map,
  GraphQL_API: GraphQL_API
};

var include$1 = TypeUtils.MakeOpaqueStringType({});

var decode$1 = include$1.decode;

var encode$1 = include$1.encode;

function parse$1(param) {
  return Relude_Globals.$great$great((function (param) {
                return Relude_Globals.$great$great(decode$1, Relude_Result.getOk, param);
              }), Relude_Option.getOrThrow, param);
}

var GraphQL_API$1 = {
  parse: parse$1,
  serialize: encode$1
};

var OTPKey_fromString = include$1.fromString;

var OTPKey_toString = include$1.toString;

var OTPKey_compare = include$1.compare;

var OTPKey_eq = include$1.eq;

var OTPKey_Ord = include$1.Ord;

var OTPKey_Set = include$1.$$Set;

var OTPKey_Map = include$1.$$Map;

var OTPKey = {
  fromString: OTPKey_fromString,
  toString: OTPKey_toString,
  decode: decode$1,
  encode: encode$1,
  compare: OTPKey_compare,
  eq: OTPKey_eq,
  Ord: OTPKey_Ord,
  $$Set: OTPKey_Set,
  $$Map: OTPKey_Map,
  GraphQL_API: GraphQL_API$1
};

function fromEnum(param) {
  if (typeof param === "number") {
    return param;
  } else {
    return 33;
  }
}

function toEnum(param) {
  switch (param) {
    case 0 :
        return /* Amphitheater */0;
    case 1 :
        return /* Bar */1;
    case 2 :
        return /* CareFacility */2;
    case 3 :
        return /* Casino */3;
    case 4 :
        return /* Caterer */4;
    case 5 :
        return /* ConventionCenter */5;
    case 6 :
        return /* CorporateDining */6;
    case 7 :
        return /* Deleted */7;
    case 8 :
        return /* Event50Plus */8;
    case 9 :
        return /* EventManagementCompany */9;
    case 10 :
        return /* EventOrganizer */10;
    case 11 :
        return /* EventServices */11;
    case 12 :
        return /* EventUnder50 */12;
    case 13 :
        return /* EventVenue */13;
    case 14 :
        return /* FoodServiceManagement */14;
    case 15 :
        return /* Fraud */15;
    case 16 :
        return /* GolfCountryClub */16;
    case 17 :
        return /* GolfCourse */17;
    case 18 :
        return /* Grocer */18;
    case 19 :
        return /* Hospital */19;
    case 20 :
        return /* Hotel */20;
    case 21 :
        return /* K12Schools */21;
    case 22 :
        return /* MealPrep */22;
    case 23 :
        return /* MovieTheatre */23;
    case 24 :
        return /* Other */24;
    case 25 :
        return /* PersonalParty */25;
    case 26 :
        return /* Resturant */26;
    case 27 :
        return /* SeniorLiving */27;
    case 28 :
        return /* SharedKitchen */28;
    case 29 :
        return /* Stadium */29;
    case 30 :
        return /* StaffingPartner */30;
    case 31 :
        return /* University */31;
    case 32 :
        return /* Venue */32;
    default:
      return ;
  }
}

var include$2 = TypeUtils.TypeClasses.WithGenerateable({
      startingIndex: 0,
      fromEnum: fromEnum,
      toEnum: toEnum
    });

function getName(str) {
  if (typeof str !== "number") {
    return str._0;
  }
  switch (str) {
    case /* Amphitheater */0 :
        return "Amphitheater";
    case /* Bar */1 :
        return "Bar";
    case /* CareFacility */2 :
        return "Care Facility";
    case /* Casino */3 :
        return "Casino";
    case /* Caterer */4 :
        return "Caterer";
    case /* ConventionCenter */5 :
        return "Convention Center";
    case /* CorporateDining */6 :
        return "Corporate Dining";
    case /* Deleted */7 :
        return "Deleted";
    case /* Event50Plus */8 :
        return "Event 50+";
    case /* EventManagementCompany */9 :
        return "Event Management Company";
    case /* EventOrganizer */10 :
        return "Event Organizer";
    case /* EventServices */11 :
        return "Event Services";
    case /* EventUnder50 */12 :
        return "Event < 50";
    case /* EventVenue */13 :
        return "Event Venue";
    case /* FoodServiceManagement */14 :
        return "Food Service Management";
    case /* Fraud */15 :
        return "Fraud";
    case /* GolfCountryClub */16 :
        return "Golf Country Club";
    case /* GolfCourse */17 :
        return "Golf Course";
    case /* Grocer */18 :
        return "Grocer";
    case /* Hospital */19 :
        return "Hospital";
    case /* Hotel */20 :
        return "Hotel";
    case /* K12Schools */21 :
        return "K-12 Schools";
    case /* MealPrep */22 :
        return "Meal Prep";
    case /* MovieTheatre */23 :
        return "Movie Theatre";
    case /* Other */24 :
        return "Other";
    case /* PersonalParty */25 :
        return "Personal Party";
    case /* Resturant */26 :
        return "Resturant";
    case /* SeniorLiving */27 :
        return "Senior Living";
    case /* SharedKitchen */28 :
        return "Shared Kitchen";
    case /* Stadium */29 :
        return "Stadium";
    case /* StaffingPartner */30 :
        return "Staffing Partner";
    case /* University */31 :
        return "University";
    case /* Venue */32 :
        return "Venue";
    
  }
}

function parseApiResponse(param) {
  if (typeof param === "string") {
    if (param === "GOLF_COUNTRY_CLUB") {
      return /* GolfCountryClub */16;
    } else if (param === "RESTAURANT") {
      return /* Resturant */26;
    } else if (param === "MOVIE_THEATER") {
      return /* MovieTheatre */23;
    } else if (param === "GROCER") {
      return /* Grocer */18;
    } else if (param === "HOSPITAL") {
      return /* Hospital */19;
    } else if (param === "UNIVERSITY") {
      return /* University */31;
    } else if (param === "CATERER") {
      return /* Caterer */4;
    } else if (param === "SENIOR_LIVING") {
      return /* SeniorLiving */27;
    } else if (param === "STAFFING_PARTNER") {
      return /* StaffingPartner */30;
    } else if (param === "CASINO") {
      return /* Casino */3;
    } else if (param === "EVENT_VENUE") {
      return /* EventVenue */13;
    } else if (param === "BAR") {
      return /* Bar */1;
    } else if (param === "EVENT_SERVICES") {
      return /* EventServices */11;
    } else if (param === "AMPHITHEATER") {
      return /* Amphitheater */0;
    } else if (param === "FRAUD") {
      return /* Fraud */15;
    } else if (param === "CARE_FACILITY") {
      return /* CareFacility */2;
    } else if (param === "EVENT_ORGANIZER") {
      return /* EventOrganizer */10;
    } else if (param === "DELETED") {
      return /* Deleted */7;
    } else if (param === "EVENT_50_") {
      return /* EventUnder50 */12;
    } else if (param === "EVENT_50") {
      return /* Event50Plus */8;
    } else if (param === "CORPORATE_DINING") {
      return /* CorporateDining */6;
    } else if (param === "EVENT_MANAGEMENT_COMPANY") {
      return /* EventManagementCompany */9;
    } else if (param === "FOOD_SERVICE_MANAGEMENT") {
      return /* FoodServiceManagement */14;
    } else if (param === "CONVENTION_CENTER") {
      return /* ConventionCenter */5;
    } else if (param === "HOTEL") {
      return /* Hotel */20;
    } else if (param === "STADIUM") {
      return /* Stadium */29;
    } else if (param === "PERSONAL_PARTY") {
      return /* PersonalParty */25;
    } else if (param === "VENUE") {
      return /* Venue */32;
    } else if (param === "SHARED_KITCHEN") {
      return /* SharedKitchen */28;
    } else if (param === "OTHER") {
      return /* Other */24;
    } else if (param === "MEAL_PREP") {
      return /* MealPrep */22;
    } else if (param === "K_12_SCHOOLS") {
      return /* K12Schools */21;
    } else {
      return /* GolfCourse */17;
    }
  } else {
    return /* FutureAddedValue */{
            _0: param.VAL
          };
  }
}

function encode$2(param) {
  return Relude_Globals.$great$great((function (str) {
                if (typeof str !== "number") {
                  return str._0;
                }
                switch (str) {
                  case /* Amphitheater */0 :
                      return "AMPHITHEATER";
                  case /* Bar */1 :
                      return "BAR";
                  case /* CareFacility */2 :
                      return "CARE_FACILITY";
                  case /* Casino */3 :
                      return "CASINO";
                  case /* Caterer */4 :
                      return "CATERER";
                  case /* ConventionCenter */5 :
                      return "CONVENTION_CENTER";
                  case /* CorporateDining */6 :
                      return "CORPORATE_DINING";
                  case /* Deleted */7 :
                      return "DELETED";
                  case /* Event50Plus */8 :
                      return "EVENT_50";
                  case /* EventManagementCompany */9 :
                      return "EVENT_MANAGEMENT_COMPANY";
                  case /* EventOrganizer */10 :
                      return "EVENT_ORGANIZER";
                  case /* EventServices */11 :
                      return "EVENT_SERVICES";
                  case /* EventUnder50 */12 :
                      return "EVENT_50_";
                  case /* EventVenue */13 :
                      return "EVENT_VENUE";
                  case /* FoodServiceManagement */14 :
                      return "FOOD_SERVICE_MANAGEMENT";
                  case /* Fraud */15 :
                      return "FRAUD";
                  case /* GolfCountryClub */16 :
                      return "GOLF_COUNTRY_CLUB";
                  case /* GolfCourse */17 :
                      return "GOLF_COURSE";
                  case /* Grocer */18 :
                      return "GROCER";
                  case /* Hospital */19 :
                      return "HOSPITAL";
                  case /* Hotel */20 :
                      return "HOTEL";
                  case /* K12Schools */21 :
                      return "K_12_SCHOOLS";
                  case /* MealPrep */22 :
                      return "MEAL_PREP";
                  case /* MovieTheatre */23 :
                      return "MOVIE_THEATRE";
                  case /* Other */24 :
                      return "OTHER";
                  case /* PersonalParty */25 :
                      return "PERSONAL_PARTY";
                  case /* Resturant */26 :
                      return "RESTAURANT";
                  case /* SeniorLiving */27 :
                      return "SENIOR_LIVING";
                  case /* SharedKitchen */28 :
                      return "SHARED_KITCHEN";
                  case /* Stadium */29 :
                      return "STADIUM";
                  case /* StaffingPartner */30 :
                      return "STAFFING_PARTNER";
                  case /* University */31 :
                      return "UNIVERSITY";
                  case /* Venue */32 :
                      return "VENUE";
                  
                }
              }), (function (prim) {
                return prim;
              }), param);
}

var Category_fromEnum = include$2.fromEnum;

var Category_toEnum = include$2.toEnum;

var Category_eq = include$2.eq;

var Category_compare = include$2.compare;

var Category_Ord = include$2.Ord;

var Category_compareWithConversion = include$2.compareWithConversion;

var Category_compareReversed = include$2.compareReversed;

var Category_OrdReversed = include$2.OrdReversed;

var Category_compareAsInt = include$2.compareAsInt;

var Category_min = include$2.min;

var Category_max = include$2.max;

var Category_lessThan = include$2.lessThan;

var Category_lt = include$2.lt;

var Category_lessThanOrEq = include$2.lessThanOrEq;

var Category_lte = include$2.lte;

var Category_greaterThan = include$2.greaterThan;

var Category_gt = include$2.gt;

var Category_greaterThanOrEq = include$2.greaterThanOrEq;

var Category_gte = include$2.gte;

var Category_clamp = include$2.clamp;

var Category_between = include$2.between;

var Category_OrdRingExtensions = include$2.OrdRingExtensions;

var Category_OrdNamed = include$2.OrdNamed;

var Category_OrdBy = include$2.OrdBy;

var Category_Set = include$2.$$Set;

var Category_SetWithNone = include$2.SetWithNone;

var Category_Map = include$2.$$Map;

var Category_list = include$2.list;

var Category_array = include$2.array;

var Category_set = include$2.set;

var Category_setWithNone = include$2.setWithNone;

var Category_cardinality = include$2.cardinality;

var Category_top = include$2.top;

var Category_bottom = include$2.bottom;

var Category_succ = include$2.succ;

var Category_pred = include$2.pred;

var Category = {
  fromEnum: Category_fromEnum,
  toEnum: Category_toEnum,
  eq: Category_eq,
  compare: Category_compare,
  Ord: Category_Ord,
  compareWithConversion: Category_compareWithConversion,
  compareReversed: Category_compareReversed,
  OrdReversed: Category_OrdReversed,
  compareAsInt: Category_compareAsInt,
  min: Category_min,
  max: Category_max,
  lessThan: Category_lessThan,
  lt: Category_lt,
  lessThanOrEq: Category_lessThanOrEq,
  lte: Category_lte,
  greaterThan: Category_greaterThan,
  gt: Category_gt,
  greaterThanOrEq: Category_greaterThanOrEq,
  gte: Category_gte,
  clamp: Category_clamp,
  between: Category_between,
  OrdRingExtensions: Category_OrdRingExtensions,
  OrdNamed: Category_OrdNamed,
  OrdBy: Category_OrdBy,
  $$Set: Category_Set,
  SetWithNone: Category_SetWithNone,
  $$Map: Category_Map,
  list: Category_list,
  array: Category_array,
  set: Category_set,
  setWithNone: Category_setWithNone,
  cardinality: Category_cardinality,
  top: Category_top,
  bottom: Category_bottom,
  succ: Category_succ,
  pred: Category_pred,
  getName: getName,
  parseApiResponse: parseApiResponse,
  encode: encode$2
};

function fromEnum$1(param) {
  if (typeof param === "number") {
    return param;
  } else {
    return 10;
  }
}

function toEnum$1(param) {
  switch (param) {
    case 0 :
        return /* DoNotSub */0;
    case 1 :
        return /* HighCommunication */1;
    case 2 :
        return /* NoLateArrivals */2;
    case 3 :
        return /* NoOverFill */3;
    case 4 :
        return /* PauseHubspotTasks */4;
    case 5 :
        return /* QualityRisk */5;
    case 6 :
        return /* ReliabilityRisk */6;
    case 7 :
        return /* SoftFreeze */7;
    case 8 :
        return /* TeamAlerts */8;
    case 9 :
        return /* WillingToRaisePay */9;
    default:
      return ;
  }
}

var include$3 = TypeUtils.TypeClasses.WithGenerateable({
      startingIndex: 0,
      fromEnum: fromEnum$1,
      toEnum: toEnum$1
    });

function parseApiResponse$1(param) {
  if (typeof param === "string") {
    if (param === "HIGH_COMMUNICATION") {
      return /* HighCommunication */1;
    } else if (param === "SOFT_FREEZE") {
      return /* SoftFreeze */7;
    } else if (param === "WILLING_TO_RAISE_PAY") {
      return /* WillingToRaisePay */9;
    } else if (param === "PAUSE_HUBSPOT_TASKS") {
      return /* PauseHubspotTasks */4;
    } else if (param === "RELIABILITY_RISK") {
      return /* ReliabilityRisk */6;
    } else if (param === "NO_OVERFILL") {
      return /* NoOverFill */3;
    } else if (param === "QUALITY_RISK") {
      return /* QualityRisk */5;
    } else if (param === "NO_LATE_ARRIVALS") {
      return /* NoLateArrivals */2;
    } else if (param === "TEAM_ALERTS") {
      return /* TeamAlerts */8;
    } else {
      return /* DoNotSub */0;
    }
  } else {
    return /* FutureAddedValue */{
            _0: param.VAL
          };
  }
}

function encode$3(param) {
  return Relude_Globals.$great$great((function (str) {
                if (typeof str !== "number") {
                  return str._0;
                }
                switch (str) {
                  case /* DoNotSub */0 :
                      return "DO_NOT_SUB";
                  case /* HighCommunication */1 :
                      return "HIGH_COMMUNICATION";
                  case /* NoLateArrivals */2 :
                      return "NO_LATE_ARRIVALS";
                  case /* NoOverFill */3 :
                      return "NO_OVERFILL";
                  case /* PauseHubspotTasks */4 :
                      return "PAUSE_HUBSPOT_TASKS";
                  case /* QualityRisk */5 :
                      return "QUALITY_RISK";
                  case /* ReliabilityRisk */6 :
                      return "RELIABILITY_RISK";
                  case /* SoftFreeze */7 :
                      return "SOFT_FREEZE";
                  case /* TeamAlerts */8 :
                      return "TEAM_ALERTS";
                  case /* WillingToRaisePay */9 :
                      return "WILLING_TO_RAISE_PAY";
                  
                }
              }), (function (prim) {
                return prim;
              }), param);
}

function fromString(param) {
  return Relude_Globals.$great$great(Relude_String.toUpperCase, (function (value) {
                switch (value) {
                  case "DO_NOT_SUB" :
                      return /* DoNotSub */0;
                  case "HIGH_COMMUNICATION" :
                      return /* HighCommunication */1;
                  case "NO_LATE_ARRIVALS" :
                      return /* NoLateArrivals */2;
                  case "NO_OVERFILL" :
                      return /* NoOverFill */3;
                  case "PAUSE_HUBSPOT_TASKS" :
                      return /* PauseHubspotTasks */4;
                  case "QUALITY_RISK" :
                      return /* QualityRisk */5;
                  case "RELIABILITY_RISK" :
                      return /* ReliabilityRisk */6;
                  case "SOFT_FREEZE" :
                      return /* SoftFreeze */7;
                  case "TEAM_ALERTS" :
                      return /* TeamAlerts */8;
                  case "WILLING_TO_RAISE_PAY" :
                      return /* WillingToRaisePay */9;
                  default:
                    return /* FutureAddedValue */{
                            _0: value
                          };
                }
              }), param);
}

var decode$2 = Curry._1(Json.Decode.variantFromString, (function (param) {
        return Relude_Globals.$great$great(fromString, Relude_Option.pure, param);
      }));

var Tag_fromEnum = include$3.fromEnum;

var Tag_toEnum = include$3.toEnum;

var Tag_eq = include$3.eq;

var Tag_compare = include$3.compare;

var Tag_Ord = include$3.Ord;

var Tag_compareWithConversion = include$3.compareWithConversion;

var Tag_compareReversed = include$3.compareReversed;

var Tag_OrdReversed = include$3.OrdReversed;

var Tag_compareAsInt = include$3.compareAsInt;

var Tag_min = include$3.min;

var Tag_max = include$3.max;

var Tag_lessThan = include$3.lessThan;

var Tag_lt = include$3.lt;

var Tag_lessThanOrEq = include$3.lessThanOrEq;

var Tag_lte = include$3.lte;

var Tag_greaterThan = include$3.greaterThan;

var Tag_gt = include$3.gt;

var Tag_greaterThanOrEq = include$3.greaterThanOrEq;

var Tag_gte = include$3.gte;

var Tag_clamp = include$3.clamp;

var Tag_between = include$3.between;

var Tag_OrdRingExtensions = include$3.OrdRingExtensions;

var Tag_OrdNamed = include$3.OrdNamed;

var Tag_OrdBy = include$3.OrdBy;

var Tag_Set = include$3.$$Set;

var Tag_SetWithNone = include$3.SetWithNone;

var Tag_Map = include$3.$$Map;

var Tag_list = include$3.list;

var Tag_array = include$3.array;

var Tag_set = include$3.set;

var Tag_setWithNone = include$3.setWithNone;

var Tag_cardinality = include$3.cardinality;

var Tag_top = include$3.top;

var Tag_bottom = include$3.bottom;

var Tag_succ = include$3.succ;

var Tag_pred = include$3.pred;

var Tag = {
  fromEnum: Tag_fromEnum,
  toEnum: Tag_toEnum,
  eq: Tag_eq,
  compare: Tag_compare,
  Ord: Tag_Ord,
  compareWithConversion: Tag_compareWithConversion,
  compareReversed: Tag_compareReversed,
  OrdReversed: Tag_OrdReversed,
  compareAsInt: Tag_compareAsInt,
  min: Tag_min,
  max: Tag_max,
  lessThan: Tag_lessThan,
  lt: Tag_lt,
  lessThanOrEq: Tag_lessThanOrEq,
  lte: Tag_lte,
  greaterThan: Tag_greaterThan,
  gt: Tag_gt,
  greaterThanOrEq: Tag_greaterThanOrEq,
  gte: Tag_gte,
  clamp: Tag_clamp,
  between: Tag_between,
  OrdRingExtensions: Tag_OrdRingExtensions,
  OrdNamed: Tag_OrdNamed,
  OrdBy: Tag_OrdBy,
  $$Set: Tag_Set,
  SetWithNone: Tag_SetWithNone,
  $$Map: Tag_Map,
  list: Tag_list,
  array: Tag_array,
  set: Tag_set,
  setWithNone: Tag_setWithNone,
  cardinality: Tag_cardinality,
  top: Tag_top,
  bottom: Tag_bottom,
  succ: Tag_succ,
  pred: Tag_pred,
  parseApiResponse: parseApiResponse$1,
  encode: encode$3,
  fromString: fromString,
  decode: decode$2
};

function fromEnum$2(param) {
  if (typeof param === "number") {
    return param;
  } else {
    return 4;
  }
}

function toEnum$2(param) {
  switch (param) {
    case 0 :
        return /* StripeCC */0;
    case 1 :
        return /* StripeACH */1;
    case 2 :
        return /* Net15 */2;
    case 3 :
        return /* Net30 */3;
    default:
      return ;
  }
}

var include$4 = TypeUtils.TypeClasses.WithGenerateable({
      startingIndex: 0,
      fromEnum: fromEnum$2,
      toEnum: toEnum$2
    });

function parseApiResponse$2(param) {
  if (typeof param === "string") {
    if (param === "NET_15") {
      return /* Net15 */2;
    } else if (param === "NET_30") {
      return /* Net30 */3;
    } else if (param === "STRIPE_ACH") {
      return /* StripeACH */1;
    } else {
      return /* StripeCC */0;
    }
  } else {
    return /* FutureAddedValue */{
            _0: param.VAL
          };
  }
}

function toString(str) {
  if (typeof str !== "number") {
    return str._0;
  }
  switch (str) {
    case /* StripeCC */0 :
        return "Stripe - CC";
    case /* StripeACH */1 :
        return "Stripe - ACH";
    case /* Net15 */2 :
        return "Net 15";
    case /* Net30 */3 :
        return "Net 30";
    
  }
}

function fromString$1(str) {
  switch (str) {
    case "NET_15" :
    case "Net 15" :
        return /* Net15 */2;
    case "NET_30" :
    case "Net 30" :
        return /* Net30 */3;
    case "STRIPE_ACH" :
    case "Stripe - ACH" :
        return /* StripeACH */1;
    case "STRIPE_CC" :
    case "Stripe - CC" :
        return /* StripeCC */0;
    default:
      return /* FutureAddedValue */{
              _0: str
            };
  }
}

function encode$4(param) {
  return Relude_Globals.$great$great((function (str) {
                if (typeof str !== "number") {
                  return str._0;
                }
                switch (str) {
                  case /* StripeCC */0 :
                      return "STRIPE_CC";
                  case /* StripeACH */1 :
                      return "STRIPE_ACH";
                  case /* Net15 */2 :
                      return "NET_15";
                  case /* Net30 */3 :
                      return "NET_30";
                  
                }
              }), (function (prim) {
                return prim;
              }), param);
}

var decode$3 = Curry._1(Json.Decode.variantFromString, (function (param) {
        return Relude_Globals.$great$great(fromString$1, Relude_Option.pure, param);
      }));

var PaymentType_fromEnum = include$4.fromEnum;

var PaymentType_toEnum = include$4.toEnum;

var PaymentType_eq = include$4.eq;

var PaymentType_compare = include$4.compare;

var PaymentType_Ord = include$4.Ord;

var PaymentType_compareWithConversion = include$4.compareWithConversion;

var PaymentType_compareReversed = include$4.compareReversed;

var PaymentType_OrdReversed = include$4.OrdReversed;

var PaymentType_compareAsInt = include$4.compareAsInt;

var PaymentType_min = include$4.min;

var PaymentType_max = include$4.max;

var PaymentType_lessThan = include$4.lessThan;

var PaymentType_lt = include$4.lt;

var PaymentType_lessThanOrEq = include$4.lessThanOrEq;

var PaymentType_lte = include$4.lte;

var PaymentType_greaterThan = include$4.greaterThan;

var PaymentType_gt = include$4.gt;

var PaymentType_greaterThanOrEq = include$4.greaterThanOrEq;

var PaymentType_gte = include$4.gte;

var PaymentType_clamp = include$4.clamp;

var PaymentType_between = include$4.between;

var PaymentType_OrdRingExtensions = include$4.OrdRingExtensions;

var PaymentType_OrdNamed = include$4.OrdNamed;

var PaymentType_OrdBy = include$4.OrdBy;

var PaymentType_Set = include$4.$$Set;

var PaymentType_SetWithNone = include$4.SetWithNone;

var PaymentType_Map = include$4.$$Map;

var PaymentType_list = include$4.list;

var PaymentType_array = include$4.array;

var PaymentType_set = include$4.set;

var PaymentType_setWithNone = include$4.setWithNone;

var PaymentType_cardinality = include$4.cardinality;

var PaymentType_top = include$4.top;

var PaymentType_bottom = include$4.bottom;

var PaymentType_succ = include$4.succ;

var PaymentType_pred = include$4.pred;

var PaymentType = {
  fromEnum: PaymentType_fromEnum,
  toEnum: PaymentType_toEnum,
  eq: PaymentType_eq,
  compare: PaymentType_compare,
  Ord: PaymentType_Ord,
  compareWithConversion: PaymentType_compareWithConversion,
  compareReversed: PaymentType_compareReversed,
  OrdReversed: PaymentType_OrdReversed,
  compareAsInt: PaymentType_compareAsInt,
  min: PaymentType_min,
  max: PaymentType_max,
  lessThan: PaymentType_lessThan,
  lt: PaymentType_lt,
  lessThanOrEq: PaymentType_lessThanOrEq,
  lte: PaymentType_lte,
  greaterThan: PaymentType_greaterThan,
  gt: PaymentType_gt,
  greaterThanOrEq: PaymentType_greaterThanOrEq,
  gte: PaymentType_gte,
  clamp: PaymentType_clamp,
  between: PaymentType_between,
  OrdRingExtensions: PaymentType_OrdRingExtensions,
  OrdNamed: PaymentType_OrdNamed,
  OrdBy: PaymentType_OrdBy,
  $$Set: PaymentType_Set,
  SetWithNone: PaymentType_SetWithNone,
  $$Map: PaymentType_Map,
  list: PaymentType_list,
  array: PaymentType_array,
  set: PaymentType_set,
  setWithNone: PaymentType_setWithNone,
  cardinality: PaymentType_cardinality,
  top: PaymentType_top,
  bottom: PaymentType_bottom,
  succ: PaymentType_succ,
  pred: PaymentType_pred,
  parseApiResponse: parseApiResponse$2,
  toString: toString,
  fromString: fromString$1,
  encode: encode$4,
  decode: decode$3
};

function fromEnum$3(param) {
  if (param) {
    return 1;
  } else {
    return 0;
  }
}

function toEnum$3(param) {
  if (param !== 0) {
    return ;
  } else {
    return /* StripeNeedApproval */0;
  }
}

var include$5 = TypeUtils.TypeClasses.WithGenerateable({
      startingIndex: 0,
      fromEnum: fromEnum$3,
      toEnum: toEnum$3
    });

function parseApiResponse$3(param) {
  if (typeof param === "string") {
    return /* StripeNeedApproval */0;
  } else {
    return /* FutureAddedValue */{
            _0: param.VAL
          };
  }
}

function toString$1(str) {
  if (str) {
    return str._0;
  } else {
    return "Stripe - Need Approval";
  }
}

function fromString$2(str) {
  switch (str) {
    case "STRIPE_NEED_APPROVAL" :
    case "Stripe - Need Approval" :
        return /* StripeNeedApproval */0;
    default:
      return /* FutureAddedValue */{
              _0: str
            };
  }
}

function encode$5(param) {
  return Relude_Globals.$great$great((function (str) {
                if (str) {
                  return str._0;
                } else {
                  return "STRIPE_NEED_APPROVAL";
                }
              }), (function (prim) {
                return prim;
              }), param);
}

var decode$4 = Curry._1(Json.Decode.variantFromString, (function (param) {
        return Relude_Globals.$great$great(fromString$2, Relude_Option.pure, param);
      }));

var PaymentNotes_fromEnum = include$5.fromEnum;

var PaymentNotes_toEnum = include$5.toEnum;

var PaymentNotes_eq = include$5.eq;

var PaymentNotes_compare = include$5.compare;

var PaymentNotes_Ord = include$5.Ord;

var PaymentNotes_compareWithConversion = include$5.compareWithConversion;

var PaymentNotes_compareReversed = include$5.compareReversed;

var PaymentNotes_OrdReversed = include$5.OrdReversed;

var PaymentNotes_compareAsInt = include$5.compareAsInt;

var PaymentNotes_min = include$5.min;

var PaymentNotes_max = include$5.max;

var PaymentNotes_lessThan = include$5.lessThan;

var PaymentNotes_lt = include$5.lt;

var PaymentNotes_lessThanOrEq = include$5.lessThanOrEq;

var PaymentNotes_lte = include$5.lte;

var PaymentNotes_greaterThan = include$5.greaterThan;

var PaymentNotes_gt = include$5.gt;

var PaymentNotes_greaterThanOrEq = include$5.greaterThanOrEq;

var PaymentNotes_gte = include$5.gte;

var PaymentNotes_clamp = include$5.clamp;

var PaymentNotes_between = include$5.between;

var PaymentNotes_OrdRingExtensions = include$5.OrdRingExtensions;

var PaymentNotes_OrdNamed = include$5.OrdNamed;

var PaymentNotes_OrdBy = include$5.OrdBy;

var PaymentNotes_Set = include$5.$$Set;

var PaymentNotes_SetWithNone = include$5.SetWithNone;

var PaymentNotes_Map = include$5.$$Map;

var PaymentNotes_list = include$5.list;

var PaymentNotes_array = include$5.array;

var PaymentNotes_set = include$5.set;

var PaymentNotes_setWithNone = include$5.setWithNone;

var PaymentNotes_cardinality = include$5.cardinality;

var PaymentNotes_top = include$5.top;

var PaymentNotes_bottom = include$5.bottom;

var PaymentNotes_succ = include$5.succ;

var PaymentNotes_pred = include$5.pred;

var PaymentNotes = {
  fromEnum: PaymentNotes_fromEnum,
  toEnum: PaymentNotes_toEnum,
  eq: PaymentNotes_eq,
  compare: PaymentNotes_compare,
  Ord: PaymentNotes_Ord,
  compareWithConversion: PaymentNotes_compareWithConversion,
  compareReversed: PaymentNotes_compareReversed,
  OrdReversed: PaymentNotes_OrdReversed,
  compareAsInt: PaymentNotes_compareAsInt,
  min: PaymentNotes_min,
  max: PaymentNotes_max,
  lessThan: PaymentNotes_lessThan,
  lt: PaymentNotes_lt,
  lessThanOrEq: PaymentNotes_lessThanOrEq,
  lte: PaymentNotes_lte,
  greaterThan: PaymentNotes_greaterThan,
  gt: PaymentNotes_gt,
  greaterThanOrEq: PaymentNotes_greaterThanOrEq,
  gte: PaymentNotes_gte,
  clamp: PaymentNotes_clamp,
  between: PaymentNotes_between,
  OrdRingExtensions: PaymentNotes_OrdRingExtensions,
  OrdNamed: PaymentNotes_OrdNamed,
  OrdBy: PaymentNotes_OrdBy,
  $$Set: PaymentNotes_Set,
  SetWithNone: PaymentNotes_SetWithNone,
  $$Map: PaymentNotes_Map,
  list: PaymentNotes_list,
  array: PaymentNotes_array,
  set: PaymentNotes_set,
  setWithNone: PaymentNotes_setWithNone,
  cardinality: PaymentNotes_cardinality,
  top: PaymentNotes_top,
  bottom: PaymentNotes_bottom,
  succ: PaymentNotes_succ,
  pred: PaymentNotes_pred,
  parseApiResponse: parseApiResponse$3,
  toString: toString$1,
  fromString: fromString$2,
  encode: encode$5,
  decode: decode$4
};

function fromEnum$4(param) {
  if (typeof param === "number") {
    if (param !== 0) {
      return 1;
    } else {
      return 0;
    }
  } else {
    return 2;
  }
}

function toEnum$4(param) {
  if (param !== 0) {
    if (param !== 1) {
      return ;
    } else {
      return /* LocationName */1;
    }
  } else {
    return /* BusinessName */0;
  }
}

var include$6 = TypeUtils.TypeClasses.WithGenerateable({
      startingIndex: 0,
      fromEnum: fromEnum$4,
      toEnum: toEnum$4
    });

function toDisplayString(string) {
  if (typeof string === "number") {
    if (string !== 0) {
      return "Location Name";
    } else {
      return "Business Name";
    }
  } else {
    return string._0;
  }
}

function parseApiResponse$4(param) {
  if (typeof param === "string") {
    if (param === "BUSINESS_NAME") {
      return /* BusinessName */0;
    } else {
      return /* LocationName */1;
    }
  } else {
    return /* FutureAddedValue */{
            _0: param.VAL
          };
  }
}

function encode$6(param) {
  return Relude_Globals.$great$great((function (str) {
                if (typeof str === "number") {
                  if (str !== 0) {
                    return "LOCATION_NAME";
                  } else {
                    return "BUSINESS_NAME";
                  }
                } else {
                  return str._0;
                }
              }), (function (prim) {
                return prim;
              }), param);
}

var PreferredShiftTitle_fromEnum = include$6.fromEnum;

var PreferredShiftTitle_toEnum = include$6.toEnum;

var PreferredShiftTitle_eq = include$6.eq;

var PreferredShiftTitle_compare = include$6.compare;

var PreferredShiftTitle_Ord = include$6.Ord;

var PreferredShiftTitle_compareWithConversion = include$6.compareWithConversion;

var PreferredShiftTitle_compareReversed = include$6.compareReversed;

var PreferredShiftTitle_OrdReversed = include$6.OrdReversed;

var PreferredShiftTitle_compareAsInt = include$6.compareAsInt;

var PreferredShiftTitle_min = include$6.min;

var PreferredShiftTitle_max = include$6.max;

var PreferredShiftTitle_lessThan = include$6.lessThan;

var PreferredShiftTitle_lt = include$6.lt;

var PreferredShiftTitle_lessThanOrEq = include$6.lessThanOrEq;

var PreferredShiftTitle_lte = include$6.lte;

var PreferredShiftTitle_greaterThan = include$6.greaterThan;

var PreferredShiftTitle_gt = include$6.gt;

var PreferredShiftTitle_greaterThanOrEq = include$6.greaterThanOrEq;

var PreferredShiftTitle_gte = include$6.gte;

var PreferredShiftTitle_clamp = include$6.clamp;

var PreferredShiftTitle_between = include$6.between;

var PreferredShiftTitle_OrdRingExtensions = include$6.OrdRingExtensions;

var PreferredShiftTitle_OrdNamed = include$6.OrdNamed;

var PreferredShiftTitle_OrdBy = include$6.OrdBy;

var PreferredShiftTitle_Set = include$6.$$Set;

var PreferredShiftTitle_SetWithNone = include$6.SetWithNone;

var PreferredShiftTitle_Map = include$6.$$Map;

var PreferredShiftTitle_list = include$6.list;

var PreferredShiftTitle_array = include$6.array;

var PreferredShiftTitle_set = include$6.set;

var PreferredShiftTitle_setWithNone = include$6.setWithNone;

var PreferredShiftTitle_cardinality = include$6.cardinality;

var PreferredShiftTitle_top = include$6.top;

var PreferredShiftTitle_bottom = include$6.bottom;

var PreferredShiftTitle_succ = include$6.succ;

var PreferredShiftTitle_pred = include$6.pred;

var PreferredShiftTitle = {
  fromEnum: PreferredShiftTitle_fromEnum,
  toEnum: PreferredShiftTitle_toEnum,
  eq: PreferredShiftTitle_eq,
  compare: PreferredShiftTitle_compare,
  Ord: PreferredShiftTitle_Ord,
  compareWithConversion: PreferredShiftTitle_compareWithConversion,
  compareReversed: PreferredShiftTitle_compareReversed,
  OrdReversed: PreferredShiftTitle_OrdReversed,
  compareAsInt: PreferredShiftTitle_compareAsInt,
  min: PreferredShiftTitle_min,
  max: PreferredShiftTitle_max,
  lessThan: PreferredShiftTitle_lessThan,
  lt: PreferredShiftTitle_lt,
  lessThanOrEq: PreferredShiftTitle_lessThanOrEq,
  lte: PreferredShiftTitle_lte,
  greaterThan: PreferredShiftTitle_greaterThan,
  gt: PreferredShiftTitle_gt,
  greaterThanOrEq: PreferredShiftTitle_greaterThanOrEq,
  gte: PreferredShiftTitle_gte,
  clamp: PreferredShiftTitle_clamp,
  between: PreferredShiftTitle_between,
  OrdRingExtensions: PreferredShiftTitle_OrdRingExtensions,
  OrdNamed: PreferredShiftTitle_OrdNamed,
  OrdBy: PreferredShiftTitle_OrdBy,
  $$Set: PreferredShiftTitle_Set,
  SetWithNone: PreferredShiftTitle_SetWithNone,
  $$Map: PreferredShiftTitle_Map,
  list: PreferredShiftTitle_list,
  array: PreferredShiftTitle_array,
  set: PreferredShiftTitle_set,
  setWithNone: PreferredShiftTitle_setWithNone,
  cardinality: PreferredShiftTitle_cardinality,
  top: PreferredShiftTitle_top,
  bottom: PreferredShiftTitle_bottom,
  succ: PreferredShiftTitle_succ,
  pred: PreferredShiftTitle_pred,
  toDisplayString: toDisplayString,
  parseApiResponse: parseApiResponse$4,
  encode: encode$6
};

function fromEnum$5(param) {
  if (typeof param === "number") {
    if (param !== 0) {
      return 1;
    } else {
      return 0;
    }
  } else {
    return 2;
  }
}

function toEnum$5(param) {
  if (param !== 0) {
    if (param !== 1) {
      return ;
    } else {
      return /* FivePercent */1;
    }
  } else {
    return /* NoFee */0;
  }
}

var include$7 = TypeUtils.TypeClasses.WithGenerateable({
      startingIndex: 0,
      fromEnum: fromEnum$5,
      toEnum: toEnum$5
    });

function parseApiResponse$5(x) {
  if (Relude_Float.approximatelyEqual(0.0001, 0.0, x)) {
    return /* NoFee */0;
  } else if (Relude_Float.approximatelyEqual(0.0001, 0.05, x)) {
    return /* FivePercent */1;
  } else {
    return /* FutureAddedValue */{
            _0: x
          };
  }
}

function encode$7(param) {
  return Relude_Globals.$great$great((function (x) {
                if (typeof x === "number") {
                  if (x !== 0) {
                    return 0.05;
                  } else {
                    return 0.0;
                  }
                } else {
                  return x._0;
                }
              }), (function (prim) {
                return prim;
              }), param);
}

var NetFeeAmount_fromEnum = include$7.fromEnum;

var NetFeeAmount_toEnum = include$7.toEnum;

var NetFeeAmount_eq = include$7.eq;

var NetFeeAmount_compare = include$7.compare;

var NetFeeAmount_Ord = include$7.Ord;

var NetFeeAmount_compareWithConversion = include$7.compareWithConversion;

var NetFeeAmount_compareReversed = include$7.compareReversed;

var NetFeeAmount_OrdReversed = include$7.OrdReversed;

var NetFeeAmount_compareAsInt = include$7.compareAsInt;

var NetFeeAmount_min = include$7.min;

var NetFeeAmount_max = include$7.max;

var NetFeeAmount_lessThan = include$7.lessThan;

var NetFeeAmount_lt = include$7.lt;

var NetFeeAmount_lessThanOrEq = include$7.lessThanOrEq;

var NetFeeAmount_lte = include$7.lte;

var NetFeeAmount_greaterThan = include$7.greaterThan;

var NetFeeAmount_gt = include$7.gt;

var NetFeeAmount_greaterThanOrEq = include$7.greaterThanOrEq;

var NetFeeAmount_gte = include$7.gte;

var NetFeeAmount_clamp = include$7.clamp;

var NetFeeAmount_between = include$7.between;

var NetFeeAmount_OrdRingExtensions = include$7.OrdRingExtensions;

var NetFeeAmount_OrdNamed = include$7.OrdNamed;

var NetFeeAmount_OrdBy = include$7.OrdBy;

var NetFeeAmount_Set = include$7.$$Set;

var NetFeeAmount_SetWithNone = include$7.SetWithNone;

var NetFeeAmount_Map = include$7.$$Map;

var NetFeeAmount_list = include$7.list;

var NetFeeAmount_array = include$7.array;

var NetFeeAmount_set = include$7.set;

var NetFeeAmount_setWithNone = include$7.setWithNone;

var NetFeeAmount_cardinality = include$7.cardinality;

var NetFeeAmount_top = include$7.top;

var NetFeeAmount_bottom = include$7.bottom;

var NetFeeAmount_succ = include$7.succ;

var NetFeeAmount_pred = include$7.pred;

var NetFeeAmount = {
  fromEnum: NetFeeAmount_fromEnum,
  toEnum: NetFeeAmount_toEnum,
  eq: NetFeeAmount_eq,
  compare: NetFeeAmount_compare,
  Ord: NetFeeAmount_Ord,
  compareWithConversion: NetFeeAmount_compareWithConversion,
  compareReversed: NetFeeAmount_compareReversed,
  OrdReversed: NetFeeAmount_OrdReversed,
  compareAsInt: NetFeeAmount_compareAsInt,
  min: NetFeeAmount_min,
  max: NetFeeAmount_max,
  lessThan: NetFeeAmount_lessThan,
  lt: NetFeeAmount_lt,
  lessThanOrEq: NetFeeAmount_lessThanOrEq,
  lte: NetFeeAmount_lte,
  greaterThan: NetFeeAmount_greaterThan,
  gt: NetFeeAmount_gt,
  greaterThanOrEq: NetFeeAmount_greaterThanOrEq,
  gte: NetFeeAmount_gte,
  clamp: NetFeeAmount_clamp,
  between: NetFeeAmount_between,
  OrdRingExtensions: NetFeeAmount_OrdRingExtensions,
  OrdNamed: NetFeeAmount_OrdNamed,
  OrdBy: NetFeeAmount_OrdBy,
  $$Set: NetFeeAmount_Set,
  SetWithNone: NetFeeAmount_SetWithNone,
  $$Map: NetFeeAmount_Map,
  list: NetFeeAmount_list,
  array: NetFeeAmount_array,
  set: NetFeeAmount_set,
  setWithNone: NetFeeAmount_setWithNone,
  cardinality: NetFeeAmount_cardinality,
  top: NetFeeAmount_top,
  bottom: NetFeeAmount_bottom,
  succ: NetFeeAmount_succ,
  pred: NetFeeAmount_pred,
  parseApiResponse: parseApiResponse$5,
  encode: encode$7
};

var include$8 = TypeUtils.MakeOpaqueStringType({});

var fromString$3 = include$8.fromString;

var encode$8 = include$8.encode;

function fromGuid(param) {
  return Relude_Globals.$great$great(CommonTypes_Guid.toString, fromString$3, param);
}

var partial_arg = Curry._1(Relude_Option.flatMap, fromGuid);

function partial_arg$1(param) {
  return Relude_Globals.$great$great((function (param) {
                return Relude_Globals.$great$great(CommonTypes_Guid.decode, Relude_Result.toOption, param);
              }), partial_arg, param);
}

function parse$2(param) {
  return Relude_Globals.$great$great(partial_arg$1, Relude_Option.getOrThrow, param);
}

var GraphQL_API$2 = {
  parse: parse$2,
  serialize: encode$8
};

var ShiftInviteCode_toString = include$8.toString;

var ShiftInviteCode_decode = include$8.decode;

var ShiftInviteCode_compare = include$8.compare;

var ShiftInviteCode_eq = include$8.eq;

var ShiftInviteCode_Ord = include$8.Ord;

var ShiftInviteCode_Set = include$8.$$Set;

var ShiftInviteCode_Map = include$8.$$Map;

var ShiftInviteCode = {
  fromString: fromString$3,
  toString: ShiftInviteCode_toString,
  decode: ShiftInviteCode_decode,
  encode: encode$8,
  compare: ShiftInviteCode_compare,
  eq: ShiftInviteCode_eq,
  Ord: ShiftInviteCode_Ord,
  $$Set: ShiftInviteCode_Set,
  $$Map: ShiftInviteCode_Map,
  fromGuid: fromGuid,
  GraphQL_API: GraphQL_API$2
};

exports.BusinessName = BusinessName;
exports.OTPKey = OTPKey;
exports.Category = Category;
exports.Tag = Tag;
exports.PaymentType = PaymentType;
exports.PaymentNotes = PaymentNotes;
exports.PreferredShiftTitle = PreferredShiftTitle;
exports.NetFeeAmount = NetFeeAmount;
exports.ShiftInviteCode = ShiftInviteCode;
/* include Not a pure module */
